<template>
    <div class="pvp-stat-radar">
        <svg :viewBox="`0 0 ${size} ${size}`" class="pvp-stat-radar__svg">
            <polygon
                v-for="ring in rings"
                :key="'ring-' + ring"
                :points="ringPoints(ring)"
                class="pvp-stat-radar__grid"
            />
            <line
                v-for="(point, i) in outerPoints"
                :key="'axis-' + i"
                :x1="center"
                :y1="center"
                :x2="point.x"
                :y2="point.y"
                class="pvp-stat-radar__axis-line"
            />
            <polygon :points="valuePoints" class="pvp-stat-radar__value" />
            <text
                v-for="(point, i) in labelPoints"
                :key="'label-' + i"
                :x="point.x"
                :y="point.y"
                text-anchor="middle"
                class="pvp-stat-radar__axis-title"
            >{{ axisMeta[i].title }}</text>
        </svg>
    </div>
</template>

<script>
// Ciste SVG - projekt zatim zadnou chart knihovnu nema. Poradi MUSI odpovidat PvpStatAxisCalculator::AXIS_KEYS na BE.
const AXIS_META = [
    {key: 'aggression'},
    {key: 'teamSize'},
    {key: 'winCertainty'},
    {key: 'opponentChoice'},
    {key: 'matchPace'},
    {key: 'bulkiness'},
    {key: 'teamExperience'},
];

export default {
    name: 'PvpStatRadar',
    props: {
        axes: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            size: 260,
            // nejdelsi popisky os by se s mensim paddingem orezavaly o okraj SVG viewBoxu
            padding: 58,
            rings: [25, 50, 75, 100],
        };
    },
    computed: {
        axisMeta() {
            return AXIS_META.map((meta) => ({
                ...meta,
                title: this.$t('pvp.statRadar.axisTitles.' + meta.key),
            }));
        },
        center() {
            return this.size / 2;
        },
        radius() {
            return this.size / 2 - this.padding;
        },
        angleStep() {
            return (2 * Math.PI) / this.axisMeta.length;
        },
        outerPoints() {
            return this.axisMeta.map((meta, i) => this.pointAt(100, i));
        },
        labelPoints() {
            return this.axisMeta.map((meta, i) => this.pointAt(122, i));
        },
        valuePoints() {
            return this.axisMeta
                .map((meta, i) => {
                    const axis = this.axes.find((a) => a.axisKey === meta.key);
                    const percent = axis ? axis.percent : 0;
                    const point = this.pointAt(percent, i);
                    return `${point.x},${point.y}`;
                })
                .join(' ');
        },
    },
    methods: {
        pointAt(percent, index) {
            const angle = index * this.angleStep - Math.PI / 2;
            const distance = (percent / 100) * this.radius;
            return {
                x: this.center + distance * Math.cos(angle),
                y: this.center + distance * Math.sin(angle),
            };
        },
        ringPoints(ring) {
            return this.axisMeta
                .map((meta, i) => {
                    const point = this.pointAt(ring, i);
                    return `${point.x},${point.y}`;
                })
                .join(' ');
        },
    },
};
</script>

<style scoped>
.pvp-stat-radar__svg {
    width: 100%;
    max-width: 280px;
    display: block;
    margin: 0 auto;
}
.pvp-stat-radar__grid {
    fill: none;
    stroke: currentColor;
    opacity: .18;
    stroke-width: 1;
}
.pvp-stat-radar__axis-line {
    stroke: currentColor;
    opacity: .18;
    stroke-width: 1;
}
.pvp-stat-radar__value {
    fill: rgba(255, 215, 0, .35);
    stroke: #FFD700;
    stroke-width: 2;
}
.pvp-stat-radar__axis-title {
    fill: currentColor;
    font-size: 9px;
    opacity: .85;
}
</style>
